module.exports = __webpack_public_path__ + "video/2300-2_YR_2021_WirelessConnection.156d497f.vtt";